import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Pipe({
  name: 'hasRequired',
  pure: false,
  standalone: true,
})
export class HasRequiredPipe implements PipeTransform {
  transform(control: AbstractControl | null): boolean {
    if (!control?.validator) return false;
    const errors = control.validator({} as AbstractControl);
    return !!errors?.['required'];
  }
}
